import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NoteService } from 'src/app/services/notes/note.service';
import { GeneralService } from 'src/app/services/general.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EmailService } from 'src/app/services/integrations/email/email.service';
import { noWhitespaceValidator } from 'src/app/utils/no-whitespace.validator';
import $ from "jquery";
import { Observable, Subject, forkJoin } from 'rxjs';
import { selectConfig } from 'src/app/utils/utils';
import { takeUntil } from 'rxjs/operators';
import { DealsService } from 'src/app/services/deals.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';
import { EmailClientService } from 'src/app/services/integrations/email/email-client.service';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.css']
})

export class NotesComponent implements OnInit, OnDestroy {

  private unsubscribe = new Subject<any>();
  user;
  @Input() showAssign = false
  @Input() modalId = "note-modal";
  id: any;
  clientList;
  dealList$: Observable<any>;
  showLoading: boolean = false;
  userNotes: any = [];
  pageContext;

  constructor(
    private noteSrv: NoteService,
    private generalSrv: GeneralService,
    private emailService: EmailService,
    private emailClientService: EmailClientService,
    private dealServ: DealsService,
    store: Store<AppState>
  ) {
    store.select("userInfo").subscribe(info => {
      this.user = info.user.id;
    });
  }

  Clientconfig = { ...selectConfig, placeholder: 'Search Client', noResultsFound: "Type here to search" };
  Dealconfig = { ...selectConfig, placeholder: 'Search Deal', noResultsFound: "Client Has No Deal" };

  addNoteForm = new FormGroup({
    content: new FormControl('', [Validators.required, noWhitespaceValidator]),
    clientID: new FormControl(''),
    dealCode: new FormControl(''),
    teamID: new FormControl(''),
    userID: new FormControl(''),
    clientName: new FormControl(''),
    dealName: new FormControl(''),
    otherID: new FormControl(''),
    otherName: new FormControl(''),
    teamName: new FormControl(''),
  })

  addNoteModalForm = new FormGroup({
    content: new FormControl('', [Validators.required, noWhitespaceValidator]),
    client: new FormControl('', [Validators.required]),
    deal: new FormControl(''),
    team: new FormControl(''),
    userID: new FormControl(''),
    clientName: new FormControl(''),
    dealName: new FormControl(''),
    otherID: new FormControl(''),
    otherName: new FormControl(''),
    teamName: new FormControl(''),
  })

  ngOnInit() {
    this.getPageContext();
  }

  onAddNote() {
    this.addNote();
  }

  /**
   * ReseT Page Form
   */
  resetForm() {
    this.addNoteForm.controls.content.reset();
  }

  /**
   * Add Note
   */
  private addNote() {
    this.showLoading = true;
    if (this.addNoteForm.valid) {
      this.noteSrv.createNote(this.addNoteForm.getRawValue())
        .pipe(takeUntil(this.unsubscribe)).subscribe(() => {
          this.discard();
          this.showLoading = false;
          this.generalSrv.sweetAlertCreateSuccessWithoutNav('Note');
          this.noteSrv.refreshNeeded$
          .subscribe(() => {
            this.getPageContext();
          })
          this.resetForm();
        }, (error) => {
          this.showLoading = false;
          this.generalSrv.sweetAlertError(this.generalSrv.getErrMsg(error));
        })
    }
  }

  /**
   * Add Modal Note
   */
  addNoteModal() {
    this.addNoteForm.patchValue({
      content: this.addNoteModalForm.value.content,
      clientID: (this.addNoteModalForm.value.client.clientId || this.addNoteModalForm.value.client.id),
      dealCode: (this.addNoteModalForm.value.deal ? this.addNoteModalForm.value.deal.code : ''),
      teamID: (this.addNoteModalForm.value.deal ? this.addNoteModalForm.value.deal.teamID : ''),
      clientName: (this.addNoteModalForm.value.client ? this.addNoteModalForm.value.client.name : ''),
      dealName: (this.addNoteModalForm.value.deal ? this.addNoteModalForm.value.deal.name : ''),
      otherID: (this.addNoteModalForm.value.client ? this.addNoteModalForm.value.client.id : ''),
      otherName: (this.addNoteModalForm.value.client ? this.addNoteModalForm.value.client.type : ''),
      userID: this.user,
    })
    this.showLoading = true;
    if (this.addNoteModalForm.valid) {
      this.noteSrv.createNote(this.addNoteForm.getRawValue())
        .pipe(takeUntil(this.unsubscribe)).subscribe(() => {
          $(`#closeNoteModal`).click();
          this.discard();
          this.showLoading = false;
          this.generalSrv.sweetAlertCreateSuccessWithoutNav('Note');
          this.noteSrv.refreshNeeded$
          .subscribe(() => {
            this.getPageContext();
          })
          this.resetForm();
        }, (error) => {
          this.showLoading = false;
          this.generalSrv.sweetAlertError(this.generalSrv.getErrMsg(error));
        })
    }
  }

  discard() {
    this.addNoteModalForm.reset();
    this.resetForm();
    this.clientList = [];
    this.addNoteModalForm.controls['client'].patchValue([]);
    this.addNoteModalForm.controls['deal'].patchValue([]);
  }

  getPageContext() {
    this.emailService.email_context.subscribe((context: any) => {
      if (!this.generalSrv.checkIfObjectIsEmpty(context)) {
        this.pageContext = context.name;
        this.getPageData(context);
      }
    });
  }

  getPageData(context) {
    switch (context.name) {
      case 'deal':
        this.addNoteForm.patchValue({ userID: this.user });
        this.addNoteForm.patchValue({ dealName: context.deal.name });
        this.addNoteForm.patchValue({ dealCode: context.data.id });
        this.addNoteForm.patchValue({ teamID: context.deal.teamID });
        break;

      case 'lead':
        this.addNoteForm.patchValue({ userID: this.user });
        this.addNoteForm.patchValue({ clientName: context.lead.sourceValue });
        this.addNoteForm.patchValue({ clientID: context.data.id });
        this.addNoteForm.patchValue({ otherID: context.data.id });
        this.addNoteForm.patchValue({ otherName: context.name });
        break;

      case 'company':
        this.addNoteForm.patchValue({ userID: this.user });
        this.addNoteForm.patchValue({ clientName: context.company.name });
        this.addNoteForm.patchValue({ clientID: context.company.clientId });
        this.addNoteForm.patchValue({ teamID: context.company.teamId });
        this.addNoteForm.patchValue({ otherID: context.company.id });
        this.addNoteForm.patchValue({ otherName: context.name });
        break;

      case 'contact':
        this.addNoteForm.patchValue({ userID: this.user });
        this.addNoteForm.patchValue({ clientName: context.contact.firstName + " " + context.contact.surName });
        this.addNoteForm.patchValue({ clientID: context.contact.clientId });
        this.addNoteForm.patchValue({ teamID: context.contact.teamId });
        this.addNoteForm.patchValue({ otherID: context.contact.id });
        this.addNoteForm.patchValue({ otherName: context.name });
        break;

      case 'salesPerson':
        this.addNoteForm.patchValue({ userID: context.data.id });
        break;

      case 'teams':
        this.addNoteForm.patchValue({ userID: this.user });
        this.addNoteForm.patchValue({ teamID: context.data.id });
        break;

      default:
        break;
    }
  }

  clientLookUp(value) {
    const inputText = value.trim()
    if (!inputText) {
      this.clearSuggestedUsers();
      return;
    }
    this.Clientconfig.noResultsFound = 'No results found!'
    const leads_lookup = this.emailClientService.fetchClientsByWildcard(value, "leads");
    const contacts_lookup = this.emailClientService.fetchClientsByWildcard(value, "contacts");
    const companies_lookup = this.emailClientService.fetchClientsByWildcard(value, "companies");
    forkJoin([leads_lookup, contacts_lookup, companies_lookup]).subscribe(
      (responses: any) => {
        let lookUp = [];

        if (responses[0].success) {
          lookUp = [...lookUp, ...responses[0].payload]
        }

        if (responses[1]) {
          lookUp = [...lookUp, ...responses[1].payload]
        }

        if (responses[2]) {
          lookUp = [...lookUp, ...responses[2].payload]
        }

        this.clientList = inputText.trim() ? [...lookUp] : [];
      })

  }

  clearSuggestedUsers() {
    this.clientList = [];
  }

  updateNoResultText() {
    const el = document.querySelector('.ngx-dropdown-container .ngx-dropdown-list-container ul li:last-child')
    el.textContent = 'No results found!'
  }

  getClientDeals() {
    this.addNoteModalForm.patchValue({ deal: '' });
    const clientInfo = this.addNoteModalForm.value.client;
    this.dealList$ = this.dealServ.getAllContactDeals("client", clientInfo.clientId)
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
